<template>
  <div>
    <el-container>

      <el-main>

        <el-row>
          <el-col :span="22"
                  :offset="1">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }"><i class="iconfont">&#xe60b;</i>&nbsp;返回首页</el-breadcrumb-item>
              <el-breadcrumb-item>
                我的报告
              </el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
          <br> <br>
          <el-col :span="22"
                  :offset="1"
                  class="whiteContainer">
            <template>
              <el-form :inline="true"
                       :model="searchForm"
                       class="demo-form-inline"
                       size="mini">
                <el-form-item label="报告名称">
                  <el-input v-model="searchForm.stock"
                            clearable
                            placeholder="报告名称"></el-input>
                </el-form-item>
                <el-form-item label="报告类型">
                  <el-select v-model="searchForm.reportType"
                             clearable
                             placeholder="报告类型">
                    <el-option label="全部"
                               value=""></el-option>
                    <el-option label="个股简报"
                               value="TINY"></el-option>
                    <el-option label="个股分析"
                               value="SIMPLE"></el-option>
                    <el-option label="投资组合"
                               value="COMPARE"></el-option>
                    <el-option label="概念报告"
                               value="CONCEPT"></el-option>
                    <el-option label="财务报告"
                               value="FINANCE"></el-option>
                    <el-option label="港股报告"
                               value="HKSTOCK"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"
                             @click="getPageList(0)">查询</el-button>
                </el-form-item>
              </el-form>
            </template>
            <template>
              <el-table v-loading="tableLoading"
                        stripe
                        :data="pageInfo.records"
                        style="width: 100%">
                <el-table-column prop="names"
                                 label="报告名称">

                </el-table-column>
                <el-table-column prop="createTime"
                                 label="创建日期">
                </el-table-column>
                <el-table-column label="报告类型">
                  <template slot-scope="scope">
                    {{scope.row.reportType | reportTypeFilter}}
                  </template>
                </el-table-column>
                <el-table-column label="文件类型"
                                 prop="fileType">
                </el-table-column>

                <el-table-column label="报告状态">
                  <template slot-scope="scope">
                    <template v-if="scope.row.status==='DOING'">
                      <span style="color:#FFD700">
                        <i class="iconfont">&#xe60c;</i>&nbsp;&nbsp;&nbsp;&nbsp;进行中
                      </span>
                    </template>
                    <template v-if="scope.row.status==='FINISH'">
                      <span style="color:green">
                        <i class="iconfont">&#xe65e;</i>&nbsp;&nbsp;&nbsp;&nbsp;已完成
                      </span>
                    </template>
                    <template v-if="scope.row.status==='FAIL'">
                      <span style="color:red">
                        <i class="iconfont">&#xee0f;</i>&nbsp;&nbsp;&nbsp;&nbsp;生成失败
                      </span>
                    </template>
                  </template>
                </el-table-column>

                <el-table-column label="操作"
                                 width="100">
                  <template slot-scope="scope">

                    <template v-if="scope.row.status==='FINISH'">
                      <el-button :disabled="scope.row.fileType==='DOC'"
                                 @click="toRead(scope.row)"
                                 type="text"
                                 size="small">阅读</el-button>
                      <el-button type="text"
                                 @click="toDownload(scope.row)"
                                 size="small">下载</el-button>
                    </template>
                    <template v-if="scope.row.status==='DOING'">
                      <el-button :disabled="true"
                                 @click="toRead(scope.row)"
                                 type="text"
                                 size="small">阅读</el-button>
                      <el-button type="text"
                                 :disabled="true"
                                 @click="toDownload(scope.row)"
                                 size="small">下载</el-button>
                    </template>
                    <template v-if="scope.row.status==='FAIL' && scope.row.userPriceId">
                      <el-button @click="toRegen(scope.row)"
                                 type="text"
                                 size="small">重新生成</el-button>
                    </template>

                  </template>
                </el-table-column>
              </el-table>
            </template>
            <br>
            <div style="text-align:center">
              <el-pagination background
                             @current-change="getPageList"
                             layout="prev, pager, next,total,jumper"
                             :current-page="pageInfo.current"
                             :page-size="pageInfo.size"
                             :total="pageInfo.total">
              </el-pagination>
            </div>
          </el-col>
        </el-row>

      </el-main>
    </el-container>

    <el-dialog width="500"
               top="0"
               :close-on-click-modal=false
               :visible.sync="pdfDialogVisible">
      <iframe :src="pdfUrl+'#toolbar=0'"
              style="width: 100%;
    height: calc(100vh - 120px);
    border: 0;" />
      <br>
      <div style="text-align:center">
        <el-button @click="toDownload(curReport)"
                   size="small">下载</el-button>
      </div>
    </el-dialog>

    <!--支付弹出框-->
    <el-dialog class="payContainer"
               :visible.sync="payDialogVisible"
               width="780px"
               center>
      <pay v-if="payDialogVisible"
           :reportId="curReport.id" />
    </el-dialog>

  </div>
</template>

<script>
import Dropzone from 'vue2-dropzone'
import axios from 'axios'
import myNav from '../components/nav'
import myMenu from '../components/menu'
import pay from '../components/pay'
export default {
  name: 'myReports',
  data: function () {
    return {
      tableLoading: true,
      pageInfo: {
        current: 1,
        size: 10,
        records: [],
        total: 1
      },
      pdfDialogVisible: false,
      pdfUrl: '',
      sourceId: '',
      curReport: {},
      payDialogVisible: false,
      operateType: '',
      searchForm: {
        reportType: ''
      }
    }
  },
  filters: {
    reportTypeFilter: function (v) {
      switch (v) {
        case 'FULL':
          return '个股分析（增强版）'
        case 'SIMPLE':
          return '个股分析'
        case 'TINY':
          return '个股分析简报'
        case 'CONCEPT':
          return '概念报告'
        case 'COMPARE':
          return '投资组合'
        case 'FINANCE':
          return '财务报告'
        case 'UNLISTED':
          return '非上市公司感知报告'
        case 'HKSTOCK':
          return '港股报告'
        case 'YEAR':
          return '年度报告'
        default:
          return v
      }
    }
  },
  computed: {
    payResult () {
      return this.$store.state.payResult
    }
  },
  watch: {
    payResult: function () {
      this.payDialogVisible = false
      this.getPageList()
      if (this.curReport.fileType === 'PDF' && this.operateType === 'read') {
        this.pdfDialogVisible = true
      } else {
        window.open('/api/web/stock/downLoadReport/' + this.curReport.sourceId)
      }
    }
  },
  methods: {
    toPay (row) {
      let _this = this
      axios.get('/api/web/price/checkReport?id=' + row.id).then(resp => {
        if (resp.data) { // 有剩余次数
          _this.$confirm('您有套餐次数可使用, 是否使用?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            axios.get('/api/web/price/payWithPackage?id=' + row.id).then(resp => {
              _this.$message({
                type: 'success',
                message: '支付成功!'
              })
              _this.getPageList()
            })
          }).catch(() => {
            _this.toRead(row)
          })
        } else {
          _this.toRead(row)
        }
      })
    },
    toRead (row) {
      let sourceId = row.sourceId
      this.operateType = 'read'
      this.pdfUrl = ''
      this.sourceId = sourceId
      this.pdfUrl = '/api/web/stock/readPdf/' + sourceId
      this.curReport = row
      if (row.hasPay === 'FALSE') {
        this.payDialogVisible = true
      } else {
        if (row.fileType === 'PDF') {
          this.pdfDialogVisible = true
        } else {
          this.toDownload(row)
        }
      }
    },
    toRegen (row) {
      let _this = this
      axios.get('/api/web/stock/reGenReport/' + row.id).then(resp => {
        _this.$message({
          type: 'success',
          message: '任务提交成功!'
        })
        _this.getPageList(_this.pageInfo.current)
      })
    },
    toDownload (row) {
      this.curReport = row
      this.operateType = 'down'
      if (row.hasPay === 'TRUE') {
        let sourceId = row.sourceId
        window.open('/api/web/stock/downLoadReport/' + sourceId)
        this.getPageList(null)
      } else {
        this.payDialogVisible = true
      }
    },

    getPageList (i) {
      if (i) {
        this.pageInfo.current = i
      }
      let _this = this
      axios.post('/api/web/stock/myReports?page=' + this.pageInfo.current + '&pageSize=' + this.pageInfo.size, this.searchForm).then(resp => {
        _this.pageInfo = resp.data
        _this.pageInfo.current = parseInt(resp.data.current)
        _this.pageInfo.total = parseInt(resp.data.total)
        _this.pageInfo.size = parseInt(resp.data.size)
        _this.tableLoading = false
        for (var i in _this.pageInfo.records) {
          if (_this.pageInfo.records[i].status === 'DOING') {
            setTimeout(function () {
              _this.getPageList()
            }, 3000)
            return
          }
        }
      })
    }
  },
  components: {
    myNav, myMenu, Dropzone, pay
  },
  mounted () {
    this.getPageList()
  }
}
</script>
<style scope>
.container-fluid {
  background: url('/static/img/courses-header.jpg');
  height: 400px;
}
.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}
.mydropzone:focus {
  background: #0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/app/myReports.vue